import { useRoute } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Button,
  Page,
  Text,
  VStack,
  View,
} from "@towersystems/roam-common-native";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PhotoImageRootParamList } from "../../../../types";
import { keys } from "../../../../utilities/i18n";

export type ImagesSentSuccessScreenProps = NativeStackScreenProps<
  PhotoImageRootParamList,
  "ImagesSentSuccessScreen"
>;

export const ImagesSentSuccessScreen = ({
  navigation,
}: ImagesSentSuccessScreenProps) => {
  const { t } = useTranslation();

  const {
    params: { imageIds },
  } = useRoute<any>();

  useEffect(() => {
    navigation.setOptions({
      title: t(keys.sentImages, { count: imageIds.length }),
    });
  }, [imageIds]);

  const footerMarkup = (
    <View>
      <Button
        isAction
        fullWidth
        onPress={() => navigation.goBack()}
        label="Continue"
      />
    </View>
  );

  return (
    <Page footer={footerMarkup}>
      <VStack centerHorizontal>
        <Text
          variant="heading2"
          style={{
            textAlign: "center",
          }}
        >
          {t(keys.sentImagesConfirmation, {
            count: imageIds.length,
          })}
        </Text>
      </VStack>
    </Page>
  );
};
